import { useRouteError } from "react-router-dom";
import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import ErrorPage from "./components/ErrorPage/ErrorPage";
import Button from "./ui/Button/Button";
import styles from "./ErrorFallback.module.scss";

function ErrorFallback() {
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <ErrorPage
      errorCode="500"
      title="Something went wrong"
      subtitle=" Our team has been notified. Please refresh and try again. If this issue persists, please contact us."
      className={styles.container}
    >
      <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
        <Button
          variant="outline"
          onClick={() => window.Intercom("showNewMessage")}
        >
          Contact us
        </Button>
        <Button variant="primary" onClick={() => location.reload()}>
          Refresh
        </Button>
      </div>
    </ErrorPage>
  );
}

export default ErrorFallback;
